import { Input } from "decorator-form";

import InputType from "common/form/InputType";
import { Entity, Field } from "typegraph";

@Entity({one: "fftext" ,update: "fftextMut"})
export default class FFHTMLWidget {

    @Field()
    public id: string;
    
	@Input({ type: InputType.TEXT_HTML, title: "Edit", required: true })
    @Field()
    public fftext: string;

    @Field()
    instance: string;
    
    @Field()
    language?: string;
}



// WEBPACK FOOTER //
// ./src/panels/institutions/FFHTMLWidget.ts